/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocationFulfillmentAvailability} from '../api'

 export const useQueryGetLocationFulfillmentAvailability = createReactQueryHook('getLocationFulfillmentAvailability', getLocationFulfillmentAvailability)
